module.exports = __webpack_public_path__ + "img/equipment-sticker-02.bb074d99.png";